import  {  useState } from 'react';
import { Card, Col, Collapse } from 'reactstrap';
import IndustryCheckBox from './IndustryCheckBox';
import HeaderWithIcon from '../../Common/HeaderWithIcon';
import { AllIndustries, IndustryHeading } from '../../../../Constant';
import { Btn } from '../../../../AbstractElements';

const Industry = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
      <Col xl="12">
        <Card>
          <HeaderWithIcon heading={IndustryHeading} isOpen={isOpen} setIsOpen={setIsOpen}/>
          <Collapse isOpen={isOpen}>
            <IndustryCheckBox/>
            <Btn className='btn-block w-100  text-center' color='primary'>{AllIndustries}</Btn>
          </Collapse>
        </Card>
      </Col>
  );
};

export default Industry;
